/* eslint-disable complexity */
import { GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM } from '@/domain/termine/hooks/graphql/queries';
import { defaultOhneKalender } from '@/domain/termine/shared/utils/defaultOhneKalender';
import { TerminKalender } from '@/domain/termine/shared/types/TerminKalender';
import { GetTagesDatenQuery, GetTagesDatenQueryVariables } from '@/gql/graphql';
import { useQuery } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';

export function useTerminKalender(
  standortIds: string[],
  zeitraum: { von: string; bis: string },
): { kalender: TerminKalender[]; error: Error | null } {
  const { t } = useTranslation();
  const { data, error } = useQuery<
    GetTagesDatenQuery,
    GetTagesDatenQueryVariables
  >(GET_TAGESDATEN_BY_STANDORTID_AND_ZEITRAUM, {
    variables: { standortIds, zeitraum },
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  if (error || !data) {
    return { kalender: [], error: error ?? new Error('No data') };
  }

  const kalenderResult = data?.termine_termineKalenderByStandortIdAndZeitraum;
  if (!kalenderResult || kalenderResult.length === 0) {
    return { kalender: [], error: null };
  }

  const kalender = kalenderResult.map((k) => new TerminKalender(k));
  return {
    kalender: defaultOhneKalender(kalender, t),
    error: error ?? null,
  };
}
